import { registerCapability } from '../../platform/capability-registry';
import { ServiceBlock } from './ServiceBlock';
import { SERVICE_ACTION_KEY_LIST, SERVICE_FIELD_KEY_LIST } from './fieldKeys';
import { resolveServicePaths } from './resolvePaths';
import type { ServiceBlockOptions } from './types';

registerCapability<ServiceBlockOptions>({
  key: 'service',
  fields: [...SERVICE_FIELD_KEY_LIST],
  actions: [...SERVICE_ACTION_KEY_LIST],
  component: ServiceBlock,
  defaultPaths: (prefix) => resolveServicePaths(prefix),
  resolvePaths: (prefix, options) => resolveServicePaths(prefix, options),
});
